import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forms-page',
  templateUrl: './forms-page.component.html',
  styleUrls: ['./forms-page.component.scss']
})
export class FormsPageComponent implements OnInit {

  public phoneNumber: any;

  public data = {
    checked: false
  };

  constructor() { }

  ngOnInit() {
  }

}
